import { render, staticRenderFns } from "./PointUse.vue?vue&type=template&id=1cd5cc9b&"
import script from "./PointUse.vue?vue&type=script&lang=js&"
export * from "./PointUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports